var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useMemo } from "react";
import Fieldset from "./Fieldset";
import FormColumn from "./FormColumn";

/**
 * Form internal component for rendering groups.
 */
var FormGroups = function FormGroups(_ref) {
  var columns = _ref.columns,
      fieldsets = _ref.fieldsets,
      props = _objectWithoutProperties(_ref, ["columns", "fieldsets"]);

  var groupCount = 0;
  var currentGroup = void 0;
  var groupedColumns = useMemo(function () {
    return columns.reduce(function (groups, column) {
      if (column.parent && column.parent !== currentGroup) {
        groups.push([]);
        currentGroup = column.parent;
      }
      groups[groups.length - 1].push(column);
      return groups;
    }, [[]]);
  }, [columns]);

  return groupedColumns.map(function (cols) {
    var columns = cols.map(function (column) {
      return React.createElement(FormColumn, _extends({ key: column.name, column: column }, props));
    });
    if (!cols[0].parent) {
      return columns;
    } else {
      var fieldset = fieldsets[groupCount];
      groupCount++;

      if (columns.length === 0) return null;
      return React.createElement(
        Fieldset,
        {
          key: groupCount,
          label: fieldset.title,
          initialCollapsed: fieldset.collapsed,
          collapsible: fieldset.collapsible
        },
        columns
      );
    }
  });
};

export default FormGroups;